<div class="relative min-h-screen h-screen bg-gradient-to-br from-gray-50 to-gray-200 dark:from-gray-900 dark:to-gray-800 text-gray-800 dark:text-gray-100 flex items-center justify-center overflow-hidden">
  
  <!-- Animated Background Blobs -->
  <div class="absolute inset-0 overflow-hidden pointer-events-none z-0">
    <div
      class="absolute -top-[20%] -left-[10%] w-[50%] h-[50%] bg-primary-100/30 rounded-full blur-[100px] animate-blob"
    ></div>
    <div
      class="absolute top-[20%] -right-[10%] w-[40%] h-[60%] bg-secondary-100/30 rounded-full blur-[100px] animate-blob animation-delay-2000"
    ></div>
    <div
      class="absolute -bottom-[20%] left-[20%] w-[50%] h-[50%] bg-accent-100/20 rounded-full blur-[100px] animate-blob animation-delay-4000"
    ></div>
  </div>

  <!-- Theme Toggle (Fixed Top Right) -->
  <div class="fixed top-6 right-6 z-50">
    <label class="switch scale-90">
      @if (!isLightMode) {
      <span class="sun"
        ><svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <g fill="#C99900">
            <circle cx="12" cy="12" r="5"></circle>
            <path
              d="m21 13h-1a1 1 0 0 1 0-2h1a1 1 0 0 1 0 2zm-17 0h-1a1 1 0 0 1 0-2h1a1 1 0 0 1 0 2zm13.66-5.66a1 1 0 0 1 -.66-.29 1 1 0 0 1 0-1.41l.71-.71a1 1 0 1 1 1.41 1.41l-.71.71a1 1 0 0 1 -.75.29zm-12.02 12.02a1 1 0 0 1 -.71-.29 1 1 0 0 1 0-1.41l.71-.66a1 1 0 0 1 1.41 1.41l-.71.71a1 1 0 0 1 -.7.24zm6.36-14.36a1 1 0 0 1 -1-1v-1a1 1 0 0 1 2 0v1a1 1 0 0 1 -1 1zm0 17a1 1 0 0 1 -1-1v-1a1 1 0 0 1 2 0v1a1 1 0 0 1 -1 1zm-5.66-14.66a1 1 0 0 1 -.7-.29l-.71-.71a1 1 0 0 1 1.41-1.41l.71.71a1 1 0 0 1 0 1.41 1 1 0 0 1 -.71.29zm12.02 12.02a1 1 0 0 1 -.7-.29l-.66-.71a1 1 0 0 1 1.36-1.36l.71.71a1 1 0 0 1 0 1.41 1 1 0 0 1 -.71.24z"
            ></path>
          </g></svg
      ></span>
      }
      @if (isLightMode) {
      <span class="moon"
        ><svg viewBox="0 0 384 512" xmlns="http://www.w3.org/2000/svg">
          <path
            d="m223.5 32c-123.5 0-223.5 100.3-223.5 224s100 224 223.5 224c60.6 0 115.5-24.2 155.8-63.4 5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-9.8 1.7-19.8 2.6-30.1 2.6-96.9 0-175.5-78.8-175.5-176 0-65.8 36-123.1 89.3-153.3 6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-6.3-.5-12.6-.8-19-.8z"
          ></path></svg
      ></span>
      }
      <input
        (ngModelChange)="toggleTheme()"
        [(ngModel)]="isLightMode"
        class="input"
        type="checkbox"
      />
      <span class="slider"></span>
    </label>
  </div>

  <div class="bg-white/40 dark:bg-gray-800/40 backdrop-blur-md border border-white/40 dark:border-gray-600/40 w-3/4 md:w-1/3 rounded-xl md:py-7 p-5 md:px-10 flex flex-col items-center justify-center relative z-10 shadow-2xl">
    <img src="assets/images/emblem.png" class="w-20" alt="">
    <span class="text-black dark:text-gray-100 text-xl font-bold mt-5 mb-2">{{ 'Reset Your Password?'  }}</span>
    <p class="text-gray-dark dark:text-gray-300 text-center">{{ 'Your new password should be different from previous passwords'  }}</p>
    <form (ngSubmit)="submitForm(form.value)" [formGroup]="form" class="w-full mt-3">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'New Password'  }}</mat-label>
        <input [type]="showPassword ? 'password' : 'text'" matInput formControlName="password">
        <button type="button" mat-icon-button matSuffix (click)="showPassword = !showPassword"
                [attr.aria-label]="'Hide'"
                [attr.aria-pressed]="showPassword">
          <mat-icon class="material-icons-outlined">{{ showPassword ? 'visibility_off' : 'visibility' }}
          </mat-icon>
        </button>
        <mat-error>
          <span
            *ngIf="!form.get('password')?.valid && form.get('password')?.touched">
              {{ 'Field is required'  }}
          </span>
        </mat-error>
      </mat-form-field>

      <mat-form-field appearance="outline">
          <mat-label>{{ 'Confirm Password'  }}</mat-label>
        <input [type]="showPassword2 ? 'password' : 'text'" matInput formControlName="confirmPassword">
        <button type="button" mat-icon-button matSuffix (click)="showPassword2 = !showPassword2"
                [attr.aria-label]="'Hide'"
                [attr.aria-pressed]="showPassword2">
          <mat-icon class="material-icons-outlined">{{ showPassword2 ? 'visibility_off' : 'visibility' }}
          </mat-icon>
        </button>
        <mat-error>
          <span
            *ngIf="!form.get('confirmPassword')?.valid && form.get('confirmPassword')?.touched">
              {{ 'Field is required'  }}
          </span>
        </mat-error>
      </mat-form-field>

      <div class="w-full mb-3">
        <button type="submit" [disabled]="!form.valid || loading" class="w-full" mat-raised-button color="primary">
          {{ 'Reset Password'  }}
        </button>
      </div>
    </form>
  </div>
</div>
